module.exports = __webpack_public_path__ + "img/social-step-1.56561308.svg";